import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Classes, FormGroup, MenuItem } from '@blueprintjs/core'

import InputSelect from '../InputSelect'
import { UserDataContext } from 'src/HOCs/withAuth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark'

import styles from './userMenu.module.scss'

class ImpersonateOrganizationMenu extends Component {
    static propTypes = {
        organizations: PropTypes.arrayOf(PropTypes.object).isRequired,
        loadingOrganizations: PropTypes.bool.isRequired,
        onLoadOrganizations: PropTypes.func.isRequired,
        onOrganizationChange: PropTypes.func.isRequired,
    }

    static contextType = UserDataContext

    state = { isFiltering: false, filteredOrganizations: [] }

    componentDidMount() {
        const { onLoadOrganizations } = this.props

        onLoadOrganizations(this.context.data.username)
    }

    organizationData() {
        const { isFiltering, filteredOrganizations } = this.state
        const { organizations } = this.props
        const organizationsToMap = isFiltering
            ? filteredOrganizations
            : organizations

        return organizationsToMap.map((organization) => ({
            value: organization.organization_id,
            label: organization.name,
            id: organization.id,
        }))
    }

    handleQueryChange = (searchTerm) => {
        const { organizations } = this.props

        if (searchTerm) {
            const filteredOrganizations = organizations.filter(
                (organization) => {
                    return organization.name
                        .toLowerCase()
                        .includes(searchTerm.toLocaleLowerCase())
                }
            )

            this.setState({ filteredOrganizations, isFiltering: true })
        } else {
            this.setState({ filteredOrganizations: [], isFiltering: false })
        }
    }

    renderOrgItem = (item, { handleClick, modifiers }) => {
        return (
            <MenuItem
                active={modifiers.active}
                key={item.id}
                onClick={handleClick}
                text={item.label}
            />
        )
    }

    renderOrganizationImpersonate() {
        const { loadingOrganizations, onOrganizationChange } = this.props

        return loadingOrganizations ? (
            <div className={styles.inputPlaceholder}>
                <p className={Classes.SKELETON} />
                <div className={Classes.SKELETON} />
            </div>
        ) : (
            <FormGroup
                label="Change organization"
                labelFor="change-org"
                className={styles.customInput}
            >
                <InputSelect
                    inputProps={{
                        id: 'change-org',
                    }}
                    additionalRightElement={
                        this.context.impersonatedOrganization ? (
                            <FontAwesomeIcon
                                icon={faXmark}
                                className={styles.clearInputIcon}
                                onClick={() => onOrganizationChange(null)}
                            />
                        ) : null
                    }
                    selectedItem={this.context.impersonatedOrganization}
                    items={this.organizationData()}
                    itemRenderer={this.renderOrgItem}
                    inputValueRenderer={(org) => org.label}
                    onItemSelect={onOrganizationChange}
                    onQueryChange={this.handleQueryChange}
                    noResults={<MenuItem disabled={true} text="No results" />}
                    popoverProps={{
                        targetClassName: 'full-width',
                        minimal: true,
                    }}
                    minimal={true}
                />
            </FormGroup>
        )
    }

    render() {
        return !this.context.data.is_local_user ? (
            <div className={'organization-menu'}>
                {this.renderOrganizationImpersonate()}
            </div>
        ) : null
    }
}

export default ImpersonateOrganizationMenu
